<link rel="stylesheet" href="/helios.css" />
@if ((items | async); as items$) {
  @if ((activeItems | async); as activeItems$) {
    <div class="hls-tab-host">
      <div class="hls-tab-headers">
        @for (item of items$ | sort:'order'; track item) {
          <user-interaction
            [interaction]="item.userInteraction"
            class="hls-tab-header"
            [ngClass]="{ 'hls-tab-header--active': activeItems$.includes(item) }"
          [renderingOptions]="{
            linkActiveOptions: {exact: false},
            forcedActive: activeItems$.includes(item)
          }">
            <div
              class="tertiary-menu-item"
            [innerText]="item.label"></div>
          </user-interaction>
        }
      </div>
      <div class="hls-tab-content">
        <ng-content></ng-content>
      </div>
    </div>
  }
}
